import React from "react";
import Particle from "../Particle";
import { educationData, experienceData } from "./ResumeData";
import "./Resume.css";
import CVFile from "../../Assets/Resume/CV_Valentin_CRETON.pdf";

export const cvData = {
  file: CVFile
};

const Card = ({
  year,
  period,
  title,
  institution,
  company,
  location,
  description,
  link,
}) => {
  return (
    <div className="resume-card animate-card">
      <div className="resume-line"></div>
      <div className="resume-content">
        <p className="resume-date">{year || period}</p>
        <h3 className="resume-title">{title}</h3>
        <p className="resume-sub">{institution || company}</p>

        {location && (
          <p className="resume-location">📍 {location}</p>
        )}

        {Array.isArray(description) ? (
          <ul className="resume-list">
            {description.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        ) : (
          description && <p className="resume-desc">{description}</p>
        )}

        {link && (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="resume-btn"
          >
            <span className="resume-btn-icon">📄</span>
            <span>Voir le diplôme</span>
          </a>
        )}
      </div>
    </div>
  );
};

const Resume = () => {
  return (
    <div className="relative min-h-screen bg-[#0d0d16] text-white overflow-hidden font-sans">
      <Particle />
      <div className="resume-cv-button-wrapper">
        <a
    	 href={cvData.file}
         className="resume-cv-button"
        >
    	  📄 Télécharger mon CV
   	</a>
      </div>

      <div
        className="container mx-auto px-6 md:px-10 py-20 relative z-10"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "4rem",
          alignItems: "flex-start",
          justifyContent: "center",
        }}
      >
        {/* Colonne Éducation */}
        <div style={{ flex: "1 1 40%", minWidth: "320px" }}>
          <h2 className="resume-header">Formations et Éducation</h2>
          {educationData.map((edu, index) => (
            <Card key={index} {...edu} />
          ))}
        </div>

        {/* Colonne Expérience */}
        <div style={{ flex: "1 1 40%", minWidth: "320px" }}>
          <h2 className="resume-header">Expériences professionnelles</h2>
          {experienceData.map((exp, index) => (
            <Card key={index} {...exp} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Resume;

